<template>
  <v-container class="pa-0 principal-body" style="height: 100%; position: absolute;top: 0;bottom: 0;right: 0;left: 0;">
    <v-row justify="center" style="font-size: 20px">
      <b>{{ $t('Notifications') }}</b>
    </v-row>
    <div class="my-view" />
    <div style="color:var(--v-primary-base) ">
    </div>
    <div style="height: 100%;overflow-y: auto;">
      <div v-if="!load" style="text-align: center;">
        <v-progress-circular
          style="margin-top: 10px"
          :size="70"
          :width="7"
          indeterminate
          color="primary"
        />
      </div>
      <div v-for="item in notifications" v-else :key="item._id">
        <NotificationItemList :from="item.from" :to="item.to" :msg="item.msg" :url="item.url" :date="item.created" />
        <v-divider class="borderDivider" />
      </div>
    </div>
  </v-container>
</template>

<script>
import ApiRepository from "@/repositories/ApiRepository";
import NotificationItemList from "components/NotificationItemList";
export default {
    name: "Notifications",
    components: {
        NotificationItemList
    },
    data () {
        return {
            notifications: [],
            load: false
        };
    },
    created () {
        this.fetch();
    },
    methods: {
        fetch () {
            ApiRepository.getNotifications().then((res) => {
                this.notifications = res.data.notifications;
            }).catch((e) => {
                console.log(e);
                const msg = 'error fetch';
                this.$root.$emit('show-snackbar', {message: this.$t('Notifications.Error get notifications'), color: 'error'});
            }).finally(() => {
                this.load = true;
            });
            ApiRepository.updateNotifications();
        }
    }
};
</script>

<style scoped>
.my-view{
  content: '';
  width: 80%;
  height: 1px;
  background-color: #0AE7C1 ;
  margin-top: 3%;
  margin-bottom: 3%;
  position: relative;
  transform: translateY(-50%);
  left: 10%;
  right: 10%;
}
.borderDivider {
    border-color: var(--v-primary-base) !important;
    border-width : 1px;
}
</style>
